import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockGraySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
      <circle cx={26} cy={26} r={18} fill="#B4BECD" />
      <circle cx={26} cy={26} r={15.366} fill="#F9FBFF" />
      <circle cx={26} cy={26} r={1.756} fill="#7689A6" transform="rotate(90 26 26)" />
      <path
        fill="#7689A6"
        d="M25.122 15.903a.878.878 0 1 1 1.756 0v9.658h-1.756zm1.323 11.521a.878.878 0 1 1 1.242-1.242l3.725 3.725a.878.878 0 0 1-1.242 1.242z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockGraySmall);
export default ForwardRef;
